import { useEffect, useState } from "react";
import { toast } from "sonner";
import { GoldDots } from "@/components/Brand";
import { errMsg, formatDate, useApi } from "@/lib/api";
import { Panel } from "@/components/admin/AdminUI";

export const AdminFeedback = () => {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/feedback").then((r) => setRows(r.data));
  useEffect(() => { load(); }, [api]); // eslint-disable-line
  const mark = async (id, status) => {
    try { await api.patch(`/admin/feedback/${id}`, { status }); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!rows) return <div className="py-16 flex justify-center"><GoldDots /></div>;
  return (
    <Panel title="Feedback" sub="Messages sent from Settings, Feedback. Each one is also emailed to support@teahusolutions.com." testId="admin-feedback">
      {rows.length === 0 ? <p className="text-ink-soft" data-testid="feedback-empty">No feedback yet.</p> : (
        <ul className="space-y-3" data-testid="feedback-list">
          {rows.map((f) => (
            <li key={f.id} className={`rounded-xl border p-5 ${f.status === "read" ? "border-rule" : "border-gold"}`} data-testid={`feedback-${f.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-3">
                <p className="font-medium text-charcoal">{f.name}{f.email && <span className="font-normal text-ink-soft"> · {f.email}</span>}</p>
                <span className="text-sm text-ink-soft">{formatDate(f.created_at, { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
              </div>
              <p className="mt-3 whitespace-pre-line leading-relaxed break-words" data-testid={`feedback-text-${f.id}`}>{f.message}</p>
              <div className="mt-4 flex flex-wrap gap-5 text-sm">
                {f.email && <a className="underline underline-offset-4" href={`mailto:${f.email}?subject=${encodeURIComponent("Your AHU feedback")}`} data-testid={`feedback-reply-${f.id}`}>Reply by email</a>}
                <button className="underline underline-offset-4 text-charcoal" onClick={() => mark(f.id, f.status === "read" ? "new" : "read")} data-testid={`feedback-mark-${f.id}`}>
                  {f.status === "read" ? "Mark as new" : "Mark as read"}
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
};
